// extracted by mini-css-extract-plugin
export default {"dialog":"x8_2lcUOnKcLKI08","titleDescription":"FyP9RtULIQIlZbkZ","vModalBody":"FXWFj2vSM_gTEgM3","vModalFooter":"IAt4f8XpeeoKUVfH","resetButton":"fwqEsMzBw3XvoN1f"};